/*
# ChartView for Marionette

- Handles default options,
- adding a chart wrapper div,
- getting dimensions,
- triggering re-renders on window resize
- d3 fallback

Based off of David Eads' ChartView for Backbone: https://gist.github.com/rnagle/9417950
* Original author & notes: David Eads (https://github.com/eads)
* Wrap D3 charting components in a simple Backbone view interface
* Provides a redrawing path, data sync, and fallback for non-d3 browsers.
* Views that extend ChartView should implement their own "draw" function and go to work.
* var collection = new Backbone.Collection([ ["Maria", 33], ["Heather", 29] ]);
* var view = new MyChartView({ $el: $("#topper-chart"), collection: collection});
*/

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var d3 = require('d3');
var template = require('./chart-view-template.hbs');

module.exports = Marionette.ItemView.extend({
	template: template,
	className: 'chart',

  constructor: function(options) {
		this.default_options = {
      base_height: 320,
			breakpoints: {
        // window width->height multiplier
        "768": 0.9,
        "420": 0.7
      },
      margin: {
        top: 20,
        right: 20,
        bottom: 20,
        left: 20
      },
      type: "",
			orientation: ""
    };

    // $.extend: Merge the contents of two or more objects together into the first object. https://api.jquery.com/jquery.extend/
    this.options = $.extend(true, this.default_options, options);

		this.options.breakpoints = this.setUpBreakpoints(this.options.breakpoints);

    // Fallback if d3 is unavailable, add some formatters otherwise.
    if (!this.d3) {
      this.draw = this.fallback_draw;
    }
    else {
      this.formatNumber = d3.format(".lf");
      this.formatCommas = d3.format(",");
      this.formatPercent = d3.format("%");
			this.formatCurrency = d3.format("$,.2f");
			this.formatCurrencyNoCents = d3.format("$,");
			this.formatInteger = d3.format("d");
			// Also added formatBigCurrency as a function
    }
    Marionette.ItemView.apply(this, arguments);
	},

	initialize: function(options){
		//console.info('initialize()');
    // Wrap chart

    this.$el.wrap( $('<div class="chart-wrapper">') );
    this.$chart_container = this.$el.parent();
    this.chart_container = this.$chart_container.get(0);
    this.get_dimensions();

    if (this.collection){
      this.collection.on("sync", _.bind(this.render, this));
		}
    else if (this.options.data)
      this.data = this.options.data;

		if(this.options.type)
			this.type = this.options.type;
		if(this.options.orientation)
			this.orientation = this.options.orientation;

		$(window).on("resize", _.debounce(_.bind(this.render, this), 200));

  },

	// Transforms breakpoint Object into a sorted Array
	setUpBreakpoints: function(breakpointsObj){
		// _.pairs: Convert an object into a list of [key, value] pairs. http://underscorejs.org/#pairs
		var breakpoints = _.pairs(breakpointsObj);

		// _.sortBy takes an Array and returns a sorted Array.
		breakpoints = _.sortBy(breakpoints, function(item) {
			return Number(item[0]);
		});
		return breakpoints;
	},
  get_dimensions: function() {
		// For some reason, if I declare custom breakpoints at MapView construction (say, in tools/layout-view.js),
		// they don't get made into an Array of breakpoints ( _.every needs this, below)

		// If the breakpoints aren't an array, make them an array!
		if( !Array.isArray(this.options.breakpoints) ){
			this.options.breakpoints = this.setUpBreakpoints(this.options.breakpoints);
		}

    var window_width = $(window).width();

    var wrapperWidth = this.$chart_container.width();
    var width = wrapperWidth - this.options.margin.left - this.options.margin.right;
    var height = this.options.base_height - this.options.margin.bottom - this.options.margin.top;
		var scale = this.options.base_scale;
    _.every(this.options.breakpoints, _.bind(function(breakpoint) {
      var width = breakpoint[0];
      if (window_width <= width) {
        var multiplier = breakpoint[1];
        height = (height - this.options.margin.bottom - this.options.margin.top) * multiplier;
				scale = scale * multiplier;
        return false;
      }
      return true;
    }, this));

    wrapperHeight = height + this.options.margin.top + this.options.margin.bottom;

    //console.log('VIEW OPTIONS', this.options);
    this.$el.height(wrapperHeight);

    this.dimensions = {
      width: width,
      height: height,
      wrapperWidth: wrapperWidth,
      wrapperHeight: wrapperHeight,
			scale: scale
    };
  },

	// The render function wraps drawing with responsivosity
  onRender: function() {

    if (this.collection)
      this.data = this.collection.toJSON();
    // this.$el.empty();
    this.get_dimensions();
    this.draw();

  	return this;
  },

  draw: function() {
    console.log("override ChartView's draw function with your d3 code");
    return this;
  },
  fallback_draw: function() {
    this.$el.html(
      '<div class="alert"><p><strong>Warning!</strong> You are using an unsupported browser. ' +
      'Please upgrade to Chrome, Firefox, or Internet Explorer version 9 or higher to view ' +
      'charts on this site.</p></div>');
    return this;
  },
  d3: function() {
    return (typeof d3 !== 'undefined');
  },

	formatBigCurrency: function(d) {
		var s = "$";
		if (d > 999999999) {
			s += Number(this.formatNumber(d/1e9)).toFixed(2) + " billion";
		} else if (d > 999999) {
			s += Number(this.formatNumber(d/1e6)).toFixed(1) + " million";
		} else {
			s += this.formatCommas(d);
		}
		return s;
	}
});
